export default __webpack_public_path__ + "984c4bbe577bafc14e5c4f9d353a0020.png";